App.config(['$mdDateLocaleProvider', function($mdDateLocaleProvider) {
    $mdDateLocaleProvider.months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
    $mdDateLocaleProvider.shortMonths = ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'];

    $mdDateLocaleProvider.days = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
    $mdDateLocaleProvider.shortDays = ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'];

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.parseDate = function (dateString) {
        let m =moment(dateString, 'L', true);
        if (m.isValid()) {
            return m.toDate();
        }
        m = moment(dateString, 'DD.MM.YYYY', true);
        if (m.isValid()) {
            return m.toDate();
        }
        m = moment(dateString, 'DD-MM-YYYY', true);
        if (m.isValid()) {
            return m.toDate();
        }
        m = moment(dateString);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = function(date) {
        if(!date){
            return '';
        }
        var tempDate = moment(date);
        return (tempDate.isValid() ? tempDate.format('DD.MM.YYYY') : '');
    };
}]);